import React from "react";
import STSStyles from "../../styles/components/StudentTestSelector.module.css";

export default function WritingTestInstructions() {
    return (
        <div className={STSStyles.instructionsContainer}>
            <h2 className={STSStyles.instructionsTitle}>Writing Test Instructions</h2>
            <p className={STSStyles.instructionsWelcome}>
                Welcome! This test will help us see how you write in English.
            </p>

            <ol className={STSStyles.instructionsList}>
                <li><strong>About the test:</strong> This is not a pass or fail test. It shows your teacher what you can do.</li>
                <li><strong>How it works:</strong> You will answer a question. Sometimes you will get a small follow-up question. Then you will see a new question.</li>
                <li><strong>Time:</strong> The test is about <b>30 minutes</b>. A clock will show your time. Try to use all the time.</li>
                <li><strong>Writing:</strong> Write in full sentences. Use your own ideas. Try your best with spelling and grammar.</li>
                <li><strong>Rules:</strong> Do not use a translator or another person. Do not close or refresh the page.</li>
            </ol>
        </div>
    );
}
